<template>
    <div>
      <matter-caution-form :getMatterCautionList="getMatterCautionList" ref="matterCautionFormModal"></matter-caution-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:left;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search')" type="text"
                  class="d-inline-block" />
              </div>
            </b-form-group>
          </div>
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('matterCaution.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="matterCautionTable"
      ref="matterCautionTable" 
      :columns="columns" 
      :rows="rows" 
      styleClass="vgt-table condensed tableSize" 
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" 
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
      :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'orderDate'">
            {{ $t('matterCaution.order_date') }}
          </span>
          <span v-else-if="props.column.field === 'orderStage'" class="text-nowrap">
            {{ $t('matterCaution.order_stage') }}
          </span>
          <span v-else-if="props.column.field === 'enforcementDate'" class="text-nowrap">
            {{ $t('matterCaution.enforcement_date') }}
          </span>
          <span v-else-if="props.column.field === 'enforcementIndemnity'" class="text-nowrap">
            {{ $t('matterCaution.enforcement_indemnity') }}
          </span>
          <span v-else-if="props.column.field === 'depositDate'">
            {{ $t('matterCaution.deposit_date') }}
          </span>
          <span v-else-if="props.column.field === 'collectedDate'" >
            {{ $t('matterCaution.collected_date') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'enforcementIndemnity'">
                <span>
                    {{ $formatMoneyTr(props.row.enforcementIndemnity) }} TRY
                </span>
            </span>
          <!-- Column: Process -->
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>
  
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
              </span>
              <b-form-select v-model="pageLength" :options="['10', '25', '50', '100']" class="mx-1"
                @input="(value) => props.perPageChanged({ currentPerPage: value })" />
              <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
            </div>
            <div>
              <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number
                align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      getMatterList: { type: Function },
      lawMatterId: {type: Number}
    },
    data() {
      return {
        pageLength: 50,
        dir: false,
        columns: [
          {
            label: this.$t('matterCaution.order_date'),
            field: `orderDate`,
            formatFn: this.$formatFn
          },
          {
            label: this.$t('matterCaution.order_stage'),
            field: `lawOrderStage`,
          },
          {
            label: this.$t('matterCaution.enforcement_date'),
            field: `enforcementDate`,
            formatFn: this.$formatFn
          },
          {
            label: this.$t('matterCaution.enforcement_indemnity'),
            field: `enforcementIndemnity`,
            tdClass: 'text-right',
            thClass: 'text-right',
          },
          {
            label: this.$t('matterCaution.deposit_date'),
            field: `depositDate`,
            formatFn: this.$formatFn
          },
          {
            label: this.$t('matterCaution.collected_date'),
            field: `collectedDate`,
            formatFn: this.$formatFn
          },
          {
            label: '',
            field: 'process',
            width: '10em',
            sortable: false
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getMatterCautionList()
    },
    methods: {
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'LawMatterCaution' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getMatterCautionList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getMatterCautionList()
              }
            })
          }
        })
      },
      async getInfo(id) {
        this.$refs.matterCautionFormModal.showInfo(id, this.lawMatterId)
      },
      getMatterCautionList() {
        this.rows = []
        const data = { id: this.lawMatterId }
        const controller = { name: 'LawMatterCaution', actionName: 'GetLawMatterCautionListByLawMatterId' }
        const payload = { controller: controller, data: data }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {
                  this.rows = response.data.lawMatterCautionList
          } else {
              this.$WarningAlert(response.data.resultMessage)
          }
        })
      },
    },
  }
  </script>
  <style lang="scss" >
  .tableSize {
    font-size: 13px!important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
  }
  </style>
  